import { Box, FormControl, MenuItem, Select } from "@mui/material";
import { useCurrency } from "./AuthContext";

// Currency flag/symbol map for the dropdown labels
const CURRENCY_LABELS = {
  RON: "🇷🇴 RON",
  USD: "🇺🇸 USD",
  EUR: "🇪🇺 EUR",
  GBP: "🇬🇧 GBP",
  CHF: "🇨🇭 CHF",
};

const CurrencySwitcher = () => {
  const {
    selectedCurrency,
    setSelectedCurrency,
    supportedCurrencies,
    ratesReady,
  } = useCurrency();

  if (!ratesReady) return null; // Don't render until rates are loaded

  return (
    <FormControl
      size="small"
      sx={{
        minWidth: 110,
        "& .MuiOutlinedInput-root": {
          color: "white",
          "& fieldset": {
            borderColor: "rgba(255, 255, 255, 0.5)",
          },
          "&:hover fieldset": {
            borderColor: "rgba(255, 255, 255, 0.8)",
          },
          "&.Mui-focused fieldset": {
            borderColor: "white",
          },
        },
        "& .MuiSvgIcon-root": {
          color: "white",
        },
      }}
    >
      <Select
        value={selectedCurrency}
        onChange={(e) => setSelectedCurrency(e.target.value)}
        sx={{
          height: "36px",
          fontSize: "0.8rem",
          fontWeight: 600,
          letterSpacing: 0.5,
        }}
        MenuProps={{
          PaperProps: {
            sx: { minWidth: 130 },
          },
        }}
      >
        {supportedCurrencies.map((currency) => (
          <MenuItem key={currency} value={currency}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                fontSize: "0.85rem",
              }}
            >
              {CURRENCY_LABELS[currency] || currency}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CurrencySwitcher;
